<script>
import NextButton from 'dashboard/components-next/button/Button.vue';
import LabelTagIcon from 'dashboard/components-next/label/LabelTagIcon.vue';

export default {
  components: {
    NextButton,
    LabelTagIcon,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '',
    },
    selected: {
      type: Boolean,
      default: false,
    },
    /**
     * Aceleres: a etiqueta pode ser APAGADA de vez (nao so tirada da conversa).
     * So vale para as que a tela de atendimento criou.
     */
    deletable: {
      type: Boolean,
      default: false,
    },
    labelId: {
      type: [Number, String],
      default: null,
    },
  },
  emits: ['selectLabel', 'deleteLabel'],

  methods: {
    onClick() {
      this.$emit('selectLabel', this.title);
    },

    onDelete() {
      this.$emit('deleteLabel', { id: this.labelId, title: this.title });
    },
  },
};
</script>

<template>
  <woot-dropdown-item>
    <!-- Aceleres: o caixote fica FORA do botao — botao dentro de botao e HTML
         invalido e o clique de dentro nao se separa do de fora.

         Caixote e nao "x" de proposito: nesta lista, clicar na linha ja
         significa TIRAR a etiqueta desta conversa. Um "x" ao lado leria como a
         mesma coisa; o caixote diz que a etiqueta deixa de existir. -->
    <div class="relative group/acl-label">
      <NextButton
        slate
        ghost
        blue
        trailing-icon
        :icon="selected ? 'i-lucide-circle-check' : ''"
        class="w-full !px-2.5 justify-between"
        :class="[{ '!flex-row': !selected }, deletable ? '!pr-8' : '']"
        @click="onClick"
      >
        <div class="flex items-center min-w-0 gap-2">
          <LabelTagIcon v-if="color" :color="color" />
          <span
            class="overflow-hidden text-ellipsis whitespace-nowrap leading-[1.1]"
            :title="title"
          >
            {{ title }}
          </span>
        </div>
      </NextButton>
      <button
        v-if="deletable"
        type="button"
        class="acl-label-delete"
        :aria-label="`Apagar etiqueta ${title}`"
        :title="`Apagar etiqueta ${title}`"
        @click.stop="onDelete"
      >
        <span class="i-lucide-trash-2 size-3.5" aria-hidden="true" />
      </button>
    </div>
  </woot-dropdown-item>
</template>

<style scoped>
.acl-label-delete {
  position: absolute;
  top: 50%;
  inset-inline-end: 0.375rem;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem;
  border: 0;
  border-radius: 0.375rem;
  background: transparent;
  color: var(--n-slate-11, #64748b);
  cursor: pointer;
  opacity: 0;
  transition:
    opacity 0.12s ease,
    color 0.12s ease;
}
.group\/acl-label:hover .acl-label-delete,
.acl-label-delete:focus-visible {
  opacity: 1;
}
.acl-label-delete:hover,
.acl-label-delete:focus-visible {
  color: #dc2626;
}
/* Sem :hover em telas de toque nao ha como chegar ao botao. */
@media (hover: none) {
  .acl-label-delete {
    opacity: 1;
  }
}
</style>
